import React from 'react';
import PolicyLayout from './PolicyLayout';

const RefundPolicyPage: React.FC = () => (
  <PolicyLayout title="Refund Policy" lastUpdated="August 1, 2026">
    <section>
      <h2>1. Eligibility for Refunds</h2>
      <p>We offer refunds under the following conditions:</p>
      <ul>
        <li>The item received is damaged or defective</li>
        <li>The wrong item was delivered</li>
        <li>The item is significantly different from its description</li>
        <li>The order was not delivered within the promised timeframe</li>
      </ul>
    </section>

    <section>
      <h2>2. Non-Refundable Items</h2>
      <p>The following are not eligible for refunds:</p>
      <ul>
        <li>Items that have been worn, washed, or altered</li>
        <li>Items without original tags and packaging</li>
        <li>Sale or discounted items (unless defective)</li>
        <li>Customised or personalised orders</li>
      </ul>
    </section>

    <section>
      <h2>3. Refund Timeline</h2>
      <p>Once your return is received and inspected:</p>
      <ul>
        <li><strong>Wallet Refund:</strong> Credited within 24 hours</li>
        <li><strong>Original Payment Method:</strong> 5–7 business days</li>
        <li><strong>Bank Transfer:</strong> 7–10 business days</li>
      </ul>
    </section>

    <section>
      <h2>4. How to Request a Refund</h2>
      <ol>
        <li>Email us at <strong><a href="mailto:sastadealpvt@gmail.com">sastadealpvt@gmail.com</a></strong> with your order number</li>
        <li>Include photos of the defective/wrong item</li>
        <li>Our team will review your request within 2 business days</li>
        <li>If approved, we will initiate the refund or send a replacement</li>
      </ol>
    </section>

    <section>
      <h2>5. Shipping Charges on Refunds</h2>
      <p>If the return is due to our error (wrong or defective item), we will cover the return shipping cost. For other returns, the customer bears the return shipping charges.</p>
    </section>

    <section>
      <h2>6. Contact</h2>
      <p>
        <strong>SASTA DEAL PRIVATE LIMITED</strong><br />
        Floor No. Gr - Fr, Building No. 114/K,<br />
        Raja S.C. Mullick Road, Near Naktala, Garia,<br />
        Kolkata, West Bengal – 700047<br />
        Email: <strong><a href="mailto:sastadealpvt@gmail.com">sastadealpvt@gmail.com</a></strong>
      </p>
    </section>
  </PolicyLayout>
);

export default RefundPolicyPage;
